import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css, keyframes } from 'styled-components';
const progress = keyframes `
  from {
    opacity: 0.5;
    transform: scaleX(0);
  }

  to {
    opacity: 0;
    transform: scaleX(1);
  }
`;
export const skeletonAnimationCss = css `
  position: relative;
  background: ${o => o.theme.color.effect.skeleton.overlay.on.background};

  &::before {
    transform-origin: left;
    animation: ${progress} 2s ease 1s infinite both;
    background: ${o => o.theme.color.fill.background};
    bottom: 0;
    content: '';
    display: block;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }
`;
export const StyledSkeleton = styled.div `
  background: ${o => o.theme.color.effect.skeleton.fill.on.background};
  height: ${o => o.$height || '100%'};
  max-width: ${o => !!o.$maxWidth && o.$maxWidth};
  width: ${o => o.$width || '100%'};

  ${o => o.$animated && skeletonAnimationCss};
`;
export const Skeleton = ({ animated, height, maxWidth, width, ...rest }) => {
    return (_jsx(StyledSkeleton, { "$animated": animated, "$height": height, "$width": width, "$maxWidth": maxWidth, ...rest }));
};
//# sourceMappingURL=index.js.map